const prefix = "/finlive";

export const route = {
  default: prefix,
  login: prefix + "/login", // 로그인
  join: prefix + "/join", // 회원가입
  join_complete: prefix + "/join/complete", // 회원가입 완료

  // -------------------------------------------------------------------------------------------------- //
  // -------------------------------------------- 홈 영역 -------------------------------------------- //
  // ------------------------------------------------------------------------------------------------ //
  home: prefix + "/home",

  // ----------------------------------------------------------------------------------------------------------- //
  // -------------------------------------------- 사용자 관리 영역 -------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  user: prefix + "/user",

  // 일반회원 관리
  user_common_member: prefix + "/user/common",
  user_common_member_detail: prefix + "/user/common/detail",
  user_common_member_edit: prefix + "/user/common/edit",

  // 탈퇴 회원 관리
  user_leave_member: prefix + "/user/leave",

  // ----------------------------------------------------------------------------------------------------------- //
  // --------------------------------------------- 강의 관리 영역 --------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  lecture: prefix + "/lecture",

  // 카테고리 관리
  lecture_category: prefix + "/lecture/category",
  lecture_category_finance: prefix + "/lecture/category/finance",
  lecture_category_paid: prefix + "/lecture/category/paid",
  lecture_category_detail: prefix + "/lecture/category/detail",
  lecture_category_edit: prefix + "/lecture/category/edit",
  lecture_category_add: prefix + "/lecture/category/add",

  // 강의 관리
  lecture_lecture: prefix + "/lecture/lecture",
  lecture_lecture_finance: prefix + "/lecture/lecture/finance",
  lecture_lecture_paid: prefix + "/lecture/lecture/paid",
  lecture_lecture_detail: prefix + "/lecture/lecture/detail",
  lecture_lecture_info: prefix + "/lecture/lecture/detail/info",
  lecture_lecture_curriculum: prefix + "/lecture/lecture/detail/curriculum",
  lecture_lecture_curriculum_edit:
    prefix + "/lecture/lecture/detail/curriculum/edit",
  lecture_lecture_curriculum_add:
    prefix + "/lecture/lecture/detail/curriculum/add",
  lecture_lecture_review: prefix + "/lecture/lecture/detail/review",
  lecture_lecture_edit: prefix + "/lecture/lecture/detail/edit",
  lecture_lecture_add: prefix + "/lecture/lecture/detail/add",

  // 온보딩 관리
  lecture_onboarding: prefix + "/lecture/onboarding",
  lecture_onboarding_detail: prefix + "/lecture/onboarding/detail",

  // ----------------------------------------------------------------------------------------------------------- //
  // --------------------------------------------- 결제 관리 영역 --------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  payment: prefix + "/payment",

  // 결제 내역 관리
  payment_pay: prefix + "/payment/pay",
  payment_pay_detail: prefix + "/payment/pay/detail",

  // 환불 내역 관리
  payment_refund: prefix + "/payment/refund",
  payment_refund_detail: prefix + "/payment/refund/detail",

  // 쿠폰 관리
  payment_coupon: prefix + "/payment/coupon",
  payment_coupon_issuance: prefix + "/payment/coupon/issuance",
  payment_coupon_history: prefix + "/payment/coupon/history",

  // 구독 관리
  payment_subscribe: prefix + "/payment/subscribe",
  payment_subscribe_list: prefix + "/payment/subscribe/list",
  payment_subscribe_detail: prefix + "/payment/subscribe/detail",
  payment_subscribe_setting: prefix + "/payment/subscribe/setting",

  // ----------------------------------------------------------------------------------------------------------- //
  // --------------------------------------------- 칼럼 관리 영역 --------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  column: prefix + "/column",

  // 카테고리 관리
  column_category: prefix + "/column/category",
  column_category_detail: prefix + "/column/category/detail",
  column_category_edit: prefix + "/column/category/edit",
  column_category_add: prefix + "/column/category/add",

  // 칼럼 관리
  column_post: prefix + "/column/post",
  column_post_detail: prefix + "/column/post/detail",
  column_post_edit: prefix + "/column/post/edit",
  column_post_add: prefix + "/column/post/add",

  // ----------------------------------------------------------------------------------------------------------- //
  // --------------------------------------------- 커뮤니티 관리 영역 --------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  community: prefix + "/community",

  // 카테고리 관리
  community_category: prefix + "/community/category",
  community_category_detail: prefix + "/community/category/detail",
  community_category_edit: prefix + "/community/category/edit",
  community_category_add: prefix + "/community/category/add",

  // 게시글 관리
  community_post: prefix + "/community/post",
  community_post_detail: prefix + "/community/post/detail",
  community_post_edit: prefix + "/community/post/edit",
  community_post_add: prefix + "/community/post/add",

  // 신고 관리
  community_report: prefix + "/community/report",
  community_report_post: prefix + "/community/report/post",
  community_report_comment: prefix + "/community/report/comment",
  community_report_post_detail: prefix + "/community/report/post/detail",
  community_report_comment_detail: prefix + "/community/report/comment/detail",

  // ----------------------------------------------------------------------------------------------------------- //
  // --------------------------------------------- 컨설팅 관리 --------------------------------------------- //
  // --------------------------------------------------------------------------------------------------------- //
  consulting: prefix + "/consulting",

  // 컨설팅 관리
  consulting_product: prefix + "/consulting/product",
  consulting_detail_info: prefix + "/consulting/product/detail/info",
  consulting_detail_review: prefix + "/consulting/product/detail/review",
  consulting_edit: prefix + "/consulting/product/edit",
  consulting_add: prefix + "/consulting/product/add",

  // form 관리
  consulting_form: prefix + "/consulting/form",
  consulting_form_prior: prefix + "/consulting/form/prior",
  consulting_form_prior_detail: prefix + "/consulting/form/prior/detail",
  consulting_form_required: prefix + "/consulting/form/required",
  consulting_form_required_detail: prefix + "/consulting/form/required/detail",

  // -------------------------------------------------------------------------------------------------------- //
  // -------------------------------------------- 고객센터 관리 영역 -------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------ //
  cs: prefix + "/cs",

  // 공지사항 관리
  cs_notice: prefix + "/cs/notice",
  cs_notice_detail: prefix + "/cs/notice/detail",
  cs_notice_create: prefix + "/cs/notice/create",

  // 1:1 관리
  cs_ask: prefix + "/cs/ask",

  // faq 관리
  cs_faq: prefix + "/cs/faq",
  cs_faq_detail: prefix + "/cs/faq/detail",
  cs_faq_create: prefix + "/cs/faq/create",
  cs_faq_edit: prefix + "/cs/faq/edit",

  // -------------------------------------------------------------------------------------------------------- //
  // -------------------------------------------- 서비스 관리 영역 -------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------ //
  service: prefix + "/service",

  // 알림 관리
  service_alarm: prefix + "/service/alarm",
  service_alarm_detail: prefix + "/service/alarm/detail",
  service_alarm_create: prefix + "/service/alarm/create",

  // 약관 관리
  service_terms: prefix + "/service/terms",
  service_terms_detail: prefix + "/service/terms/detail",
  service_terms_edit: prefix + "/service/terms/edit",

  // 기본 관리
  service_basic: prefix + "/service/basic",
  service_basic_edit: prefix + "/service/basic/edit",

  // 팝업 관리
  service_popup: prefix + "/service/popup",
  service_popup_detail: prefix + "/service/popup/detail",
  service_popup_edit: prefix + "/service/popup/edit",
  service_popup_create: prefix + "/service/popup/create",

  // 배너 관리
  service_banner: prefix + "/service/banner",
  service_banner_main: prefix + "/service/banner/main",
  service_banner_finance: prefix + "/service/banner/finance",

  // -------------------------------------------------------------------------------------------------------------- //
  // -------------------------------------------- 관리자 회원 관리 영역 -------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------ //
  manager: prefix + "/manager",
  manager_detail: prefix + "/manager/detail",
  manager_edit_root: prefix + "/manager/edit/root",
  manager_edit_admin: prefix + "/manager/edit/admin",
};
